import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationDashboardRepository } from '../../../infrastructure/repositories/investigation-dashboard.repository';
import { GetInvestigationDashboardWidgetDataQuery } from './get-investigation-dashboard-widget-data.query';
import { GetInvestigationDashboardWidgetDataResult } from './get-investigation-dashboard-widget-data.result';

@Injectable({ providedIn: 'root' })
export class GetInvestigationDashboardWidgetDataUseCase {
  private readonly _repository = inject(InvestigationDashboardRepository);

  public execute(query: GetInvestigationDashboardWidgetDataQuery): Observable<GetInvestigationDashboardWidgetDataResult> {
    return this._repository
      .getWidgetData(query.widgetId, query.timeframe)
      .pipe(map((widgetData) => ({ widgetData })));
  }
}
